import {Avatar, Button, ColorPicker, Flex, Input, Popover} from "antd";
import ButtonGroup from "antd/es/button/button-group";
import {saveNarrator} from "../../../feature/project/narrationSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight, faSave} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect} from "react";
import {Narrator} from "../../../feature/project/Shot";
import {useParams} from "react-router-dom";
import {useAppDispatch} from "../../../feature/tools";
import {Asset} from "../../../feature/project/fields";
import {AssetsBrowser} from "./AssetsBrowser";

export const NarratorManagerItem = (props: {
    narrator: Narrator,
    onNarratorSelected: (narrator: Narrator) => void
}) => {
    const [item, setItem] = React.useState(props.narrator)
    const {projectId} = useParams()
    const dispatch = useAppDispatch()
    const [assetBrowser, setAssetBrowser] = React.useState(false)

    useEffect(() => {
        setItem(props.narrator)
    }, [props.narrator]);

    return (
        <Flex gap={12} style={{padding: 12}}>
            <Popover
                onOpenChange={setAssetBrowser}
                open={assetBrowser}
                trigger={'click'}
                placement={'rightTop'}
              overlayInnerStyle={{marginTop:-10}}
                arrow={false}
                content={
                <AssetsBrowser
                    categories={['Character', 'Object']}
                    onAssetSelected={(asset: Asset | null) => {
                        setItem({...item, icon: asset?.content ?? null})
                        setAssetBrowser(false)
                    }}
                />
            }
            >
                <Avatar onClick={() => setAssetBrowser(true)} style={{minWidth: '32px'}} shape={"square"}
                        src={item.icon ? item.icon : '/images/placeholder.png'}/>
            </Popover>
            <Input
                style={{flexGrow: 1}}
                value={item.title}
                onChange={(e) => {
                    setItem({...item, title: e.target.value})
                }}
                placeholder={item.id ? 'Narrator Name (e.g. John)' : 'New Narrator Name (e.g. John)'}
            />
            <ColorPicker
                defaultValue={item.color}
                allowClear={true}
                onClear={() => {
                    setItem({...item, color: null})
                }}
                onChange={(color) => setItem({...item, color: color.toHexString()})}/>
            <ButtonGroup>
                <Button
                    disabled={item.title == props.narrator.title && item.color == props.narrator.color && item.icon == props.narrator.icon}
                    type={"text"}
                    onClick={() => {
                        if (projectId) {
                            dispatch(saveNarrator({
                                projectId: parseInt(projectId),
                                narrator: {...item, color: item.color && item.color.length > 0 ? item.color : null}
                            }))
                        }
                    }}
                ><FontAwesomeIcon icon={faSave}/></Button>
                <Button
                    disabled={!item.id}
                    type={"text"}
                    onClick={() => {
                        if (item.id) {
                            props.onNarratorSelected(item)
                        }
                    }}
                ><FontAwesomeIcon icon={faAngleRight}/></Button>
            </ButtonGroup>
        </Flex>
    )
}